import type {ReservationPost} from "../generated/models";

// TODO: remove this after we remove `isGuest` from the reservation posts
export function getRoleFromPost<
    T extends {
        role?: ReservationPost["role"];
        isGuest?: boolean;
    }
>(post: T) {
    // use `role` by default
    return post.role
        ? post.role
        : // keep using the old value until it's fully removed
        typeof post.isGuest !== "undefined"
        ? post.isGuest
            ? "guest"
            : "host"
        : "host";
}
